const prefix = "edcForms";

export const SAVE_FORM_DATA = `${prefix}/SET_FORM_DATA`;
export const SAVE_FORM_NAME = `${prefix}/SET_FORM_NAME`;
export const SAVE_FORM_MODE = `${prefix}/SAVE_FORM_MODE`;

export default prefix;
